// DoughForm defaults

import {
  BATCH_TYPE_TOTAL_WT,
  formTypeRatioDough,
  LEVAIN_PCT_TYPE_TOTAL_WT,
  liquidLevain
} from "../shared/Types";
import {defaultLevainFermPct} from "../shared/FermentationTiming";

const mainFormDataDefaults = {
  formName: `New Formula`,
  formType: formTypeRatioDough,
  labels: [],
  attribution: '',
  numBatches: 1,
  batchSize: 900,
  batchType: BATCH_TYPE_TOTAL_WT,
  hydrationPct: 72,
  process: {},
  starterType: LEVAIN_PCT_TYPE_TOTAL_WT,
  starterPct: 20,
  starterHydrationPct: 100,
  yeastRatioId: 0,
  yeastPct: 0,
  includePreferment: false,
  prefermentPffPct: 0,
  prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
  pffBakersPct: false,
  prefermentData: undefined,
  flour: [
    {
      name: 'Bread Flour',
      percent: 100,
      percentStr: '100',
      id: 'b.1'
    }
  ],
  liquid: [
    {
      name: 'Water',
      percent: 100,
      percentStr: '100',
      id: 'b.1'
    }
  ],
  mixin: [
    {
      name: 'Salt',
      percent: 1.85,
      id: 'b.1'
    }
  ],
  submixes: [
  ],
  toppings: [
  ],
  costData: [
  ],
  notes: ''
}


const prefermentDefaults = {
  prefermentType: liquidLevain,
  hydrationPct: 100,
  yeastRatioId: 0,
  yeastPct: 0,
  starterType: LEVAIN_PCT_TYPE_TOTAL_WT,
  starterPct: 20,
  starterHydrationPct: 100,
  levainFermPct: defaultLevainFermPct,
  levainFermTempF: '75',
  addBuffer: true,
  flour: [
    {
      name: 'All Purpose',
      percent: 100,
      percentStr: '100',
      id: 'b.1'
    }
  ],
  liquid: [
    {
      name: 'Water',
      percent: 100,
      percentStr: '100',
      id: 'b.1'
    }
  ],
  mixin: []
}

// structure to represent yeast quantity in terms of number of 1/16 tsp units
//   i.e. value is just an index/identifier for the UI dropdown and multiplier is the # of 1/16 tsp units

export const maxUnitsToBake = 900
export const maxBatchSize = 900000

export const totalHydroMin = 5
export const totalHydroMax = 200
export const totalHydroSliderMin = 40
export const totalHydroSliderMax = 100

export const prefHydroMin = 30
export const prefHydroMax = 200
export const prefHydroSliderMin = 30
export const prefHydroSliderMax = 150

export const prefStarterMin = 1
export const prefStarterMax = 500
export const prefStarterSliderMin = 1
export const prefStarterSliderMax = 100
export const prefYeastMin = 1
export const prefYeastSliderMin = 1

export const mainLevainMin = 0
export const mainLevainMax = 900
export const mainLevainSliderMin = 0
export const mainLevainSliderMax = 100
export const mainYeastMin = 0
export const mainYeastSliderMin = 0

export const mainPrefMin = 1


export {mainFormDataDefaults, prefermentDefaults}